import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby'
import Category from './category';
import "./layout.css";

const Header = (props) => {

  const [useAccentColor, setUseAccentColor] = useState(false);
  const [showingMenu, setShowingMenu] = useState(false);
  const [categoryMenuStatus, setCategoryMenuStatus] = useState('inactive');

  useEffect(() => {
    if (props.alwaysUseAccentColorForNav) {
      setUseAccentColor(true);
    } else {
      window.addEventListener('scroll', () => {
        if (window.scrollY < 20) {
          setUseAccentColor(false);
        } else {
          setUseAccentColor(true);
        }
      });
    }
  }, []);

  const showMenu = () => {
    if (!showingMenu) {
      setShowingMenu(true);
    } else {
      setShowingMenu(false);
      setCategoryMenuStatus('inactive');
    }
  }

  const showCategoryMenu = () => {
    if (categoryMenuStatus !== 'active') {
      setCategoryMenuStatus('active');
    } else {
      setCategoryMenuStatus('inactive');
    }
  }

  const navContainerClasses = () => {
    return 'navContainer ' + (useAccentColor ? 'blueBackground' : '')
  }

  return (
  <header>
    <div className = {navContainerClasses()}>
      <div>
        <Link to='/#slider' className= "logo-link">
          <h2 className= "mansysco-logo">ManSysCo</h2>
        </Link>
      </div>
      <nav className={showingMenu ? 'active' : ''}>
        <ul id='mainNav'>
          <li className={categoryMenuStatus} onClick={showCategoryMenu}>
            <p>Projects</p>
          </li>
          <li className={categoryMenuStatus}>
            <Link to='/#service'>Services</Link>
          </li>
          <li className={categoryMenuStatus}>
            <Link to='/#contact'>Contact</Link>
          </li>
        </ul>
      </nav>
      <button
        className={'toggleBtn ' + (showingMenu ? 'active' : '')}
        onClick ={showMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>
      </div>
      <Category 
        divClass = {'exampleContainer ' + categoryMenuStatus} 
        listClass={'subMenus ' + categoryMenuStatus}
        onClose= {() => showMenu()} 
      />
  </header>
  );
};

export default Header;
